export enum ReassignUserTabs {
    REASSIGN = 'REASSIGN',
    TRACKING = 'TRACKING'
}